import React from 'react';

const SkeletonLoader = ({ 
  variant = 'default', 
  width = '100%', 
  height = '20px',
  className = '',
  count = 1,
  circle = false
}) => {
  const getVariantStyles = () => {
    switch (variant) {
      case 'badge':
        return {
          width: '100px',
          height: '28px',
          borderRadius: '9999px',
          backgroundColor: 'rgba(30, 58, 95, 0.1)'
        };
      case 'avatar':
        return {
          width: '40px',
          height: '40px',
          borderRadius: '9999px',
          backgroundColor: 'rgba(30, 58, 95, 0.1)'
        };
      case 'text':
        return {
          width: width,
          height: '16px',
          borderRadius: '4px',
          backgroundColor: 'rgba(30, 58, 95, 0.08)'
        };
      case 'title':
        return {
          width: width,
          height: '24px',
          borderRadius: '6px',
          backgroundColor: 'rgba(30, 58, 95, 0.1)'
        };
      case 'button':
        return {
          width: '120px',
          height: '36px',
          borderRadius: '8px',
          backgroundColor: 'rgba(30, 58, 95, 0.1)'
        };
      case 'card':
        return {
          width: '100%',
          height: '200px',
          borderRadius: '12px',
          backgroundColor: 'rgba(30, 58, 95, 0.08)'
        };
      case 'timeline-step':
        return {
          width: '32px',
          height: '32px',
          borderRadius: '9999px',
          backgroundColor: 'rgba(30, 58, 95, 0.1)'
        };
      default:
        return {
          width: circle ? height : width,
          height: height,
          borderRadius: circle ? '9999px' : '8px',
          backgroundColor: 'rgba(30, 58, 95, 0.1)'
        };
    }
  };

  const baseStyles = getVariantStyles();

  const skeletonStyle = {
    ...baseStyles,
    position: 'relative',
    overflow: 'hidden',
    animation: 'skeleton-pulse 1.5s ease-in-out infinite'
  };

  const shimmerStyle = {
    position: 'absolute',
    top: 0,
    left: '-100%',
    width: '100%',
    height: '100%',
    background: 'linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent)',
    animation: 'skeleton-shimmer 1.5s ease-in-out infinite'
  };

  const skeletons = Array.from({ length: count }, (_, index) => (
    <div key={index} style={skeletonStyle} className={className}>
      <div style={shimmerStyle} />
    </div>
  ));

  return count > 1 ? (
    <div className="space-y-2">{skeletons}</div>
  ) : (
    skeletons?.[0]
  );
};

export default SkeletonLoader;